import { useCallback } from 'react';
export const useOnScroll = ({ ref, onScrollEnd }) => {
    const onScroll = useCallback(() => {
        if (!ref.current || !onScrollEnd)
            return;
        const sum = ref.current.scrollTop + ref.current.clientHeight;
        if (sum > ref.current.scrollHeight - 32)
            onScrollEnd();
    }, [ref, onScrollEnd]);
    return onScroll;
};
